import { toast, Zoom } from "react-toastify";

export function errorMessage(message) {
  toast.error(message, {
    position: "top-center",
    transition: Zoom,
    closeOnClick: false,
    pauseOnHover: false,
    draggablePercent: 60,
    progress: undefined,
  });
};

export function successMessage(message) {
  toast.success(message, {
    position: "top-center",
    autoClose: 2000,
    transition: Zoom,
    closeOnClick: false,
    pauseOnHover: false,
    draggablePercent: 60,
    /* progress: undefined, */
    hideProgressBar: true,
    theme: "colored",
  });
};
